/* eslint-disable radix */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import {
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  Spinner,
  InputGroupAddon,
} from 'reactstrap';
import qs from 'qs';
import SelectInput from '~/components/selectInput/SelectInput';
import api from '~/services/api';

import { Container } from './styles';

function CadastroCard({
  setForm,
  form,
  handleSignupUser,
  loading,
  setTogglePassword,
  togglePassword,
  setLoading,
}) {
  const [companyData, setCompanyData] = useState([{}]);

  useEffect(() => {
    async function getData() {
      const params = {
        skip: 0,
        take: 1000,
      };
      await api
        .get(`/Pessoa/GetPessoaPaginado?${qs.stringify(params)}`)
        .then((response) => {
          const { data } = response.data;
          setLoading(false);
          setCompanyData(data);
        });
    }
    getData();
  }, []);
  return (
    <Container>
      <h1>Cadastrar usuário</h1>
      <Form style={{ width: '100%' }} onSubmit={handleSignupUser}>
        <FormGroup>
          <SelectInput
            margin="0"
            width="100%"
            label="Selecione a empresa"
            form={form}
            valueKey="idPessoaEmpresa"
            labelKey="razaoSocialNome"
            setForm={setForm}
            value={form.idPessoaEmpresa}
            options={companyData}
            placeholder="Escolha uma opção"
            state="idPessoaEmpresa"
            onChange={() => {}}
          />
        </FormGroup>
        <FormGroup>
          <Label htmlFor="user">Usuário: </Label>
          <Input
            placeholder="Insira o usuário"
            type="text"
            name="user"
            id="user"
            onChange={(e) => setForm({ ...form, user: e.target.value })}
            required
          />
        </FormGroup>
        <FormGroup>
          <Label htmlFor="email">
            <span>(opcional)</span> Email:
          </Label>
          <Input
            placeholder="Insira o email do usuário"
            type="email"
            name="email"
            id="email"
            onChange={(e) => setForm({ ...form, email: e.target.value })}
            required
          />
        </FormGroup>
        <Label>Senha</Label>
        <div className="inputArea">
          <Input
            required
            type={!togglePassword ? 'password' : 'text'}
            name="password"
            placeholder="Insira a senha do usuário"
            onChange={(e) => setForm({ ...form, password: e.target.value })}
          />
          <InputGroupAddon addonType="append">
            <Button
              color="primary"
              onClick={() => {
                setTogglePassword(!togglePassword);
              }}
            >
              {!togglePassword ? <FaEye /> : <FaEyeSlash />}
            </Button>
          </InputGroupAddon>
        </div>

        {loading ? (
          <Button color="primary" disabled>
            <Spinner size="sm" color="#FFF" />
          </Button>
        ) : (
          <Button color="primary" onClick={handleSignupUser}>
            Cadastrar
          </Button>
        )}
      </Form>
    </Container>
  );
}

export default CadastroCard;
